export default import.meta.ROLLDOWN_FILE_URL_BwOoCx$_i5hBOYwUpPCWig